// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import govprogEntity from './entities/govprog.json';
import govprogMenu from '../pages/govprog/menu.json';
import govprogFullForm from '../pages/govprog/forms/full.json';
import govprogContextForm from '../pages/govprog/forms/context.json';
import govprogMiniForm from '../pages/govprog/forms/mini.json';
import govprogLookupForm from '../pages/govprog/forms/lookup.json';
import govprogTableView from '../pages/govprog/views/table.json';
import govprogStagesView from '../pages/govprog/views/stages.json';
import govprogCardsView from '../pages/govprog/views/cards.json';
import govprogInlineView from '../pages/govprog/views/inline.json';
import govprogBacklogView from '../pages/govprog/views/backlog.json';
import govprogSplitView from '../pages/govprog/views/split.json';
import govprogCalendarView from '../pages/govprog/views/calendar.json';
import govprogDashboardView from '../pages/govprog/views/dashboard.json';

/** Тип запису «Зобов’язання Уряду» зі сторінками пакета: меню, форми та подання з pages/govprog/. */
export const govprogDefinition: IRecordTypeDefinition = {
  ...govprogEntity,
  views: assembleViewSet({
      table: govprogTableView,
      stages: govprogStagesView,
      cards: govprogCardsView,
      inline: govprogInlineView,
      backlog: govprogBacklogView,
      split: govprogSplitView,
      calendar: govprogCalendarView,
      dashboard: govprogDashboardView,
  }),
  form: govprogFullForm,
  forms: { full: govprogFullForm, context: govprogContextForm, mini: govprogMiniForm, lookup: govprogLookupForm },
  menu: govprogMenu,
} as IRecordTypeDefinition;
